/**
 * INKO leaderboard combo filter — a pair of pill selectors for
 * difficulty (easy/medium/hard) and reading mode (slow/classic/keywords/porno).
 *
 * Used by:
 *   - InkoDaily result screen (per-day per-combo top 10)
 *   - Inko classic landing / result screen (all-time per-combo top 10)
 */
import React from "react";
import { READING_MODES, READING_MODE_LABELS } from "../../lib/inko";

const DIFF_MODES = ["easy", "medium", "hard"];
const DIFF_LABELS = { easy: "Easy", medium: "Medium", hard: "Hard" };

export function ComboFilter({ mode, setMode, readingMode, setReadingMode, testidPrefix = "inko-combo" }) {
    return (
        <div className="mb-4 space-y-2" data-testid={`${testidPrefix}-filter`}>
            <PillRow
                label="Obtížnost"
                items={DIFF_MODES}
                active={mode}
                onSelect={setMode}
                labels={DIFF_LABELS}
                testidPrefix={`${testidPrefix}-mode`}
            />
            <PillRow
                label="Rytmus"
                items={READING_MODES}
                active={readingMode}
                onSelect={setReadingMode}
                labels={READING_MODE_LABELS}
                testidPrefix={`${testidPrefix}-rm`}
            />
        </div>
    );
}

function PillRow({ label, items, active, onSelect, labels, testidPrefix }) {
    return (
        <div className="flex items-center gap-2 flex-wrap">
            <span className="font-mono text-[10px] uppercase tracking-[0.3em] text-white/40 shrink-0 w-20">
                {label}
            </span>
            <div className="flex flex-wrap gap-1">
                {items.map((it) => (
                    <button
                        key={it}
                        type="button"
                        onClick={() => onSelect(it)}
                        data-testid={`${testidPrefix}-${it}`}
                        className={`font-mono text-[10px] uppercase tracking-widest px-2.5 py-1 border transition-colors ${
                            active === it
                                ? "border-fa-cream bg-fa-cream/10 text-fa-cream"
                                : "border-white/15 text-white/50 hover:border-white/40 hover:text-fa-cream"
                        }`}
                    >
                        {labels[it] || it}
                    </button>
                ))}
            </div>
        </div>
    );
}

export default ComboFilter;
